import React from 'react';
import styled from 'styled-components';
import { FormattedMarkdown } from '@qover/react-intl';
import { CaptionMixin } from '@qover/typography';

const Container = styled.div`
  ${CaptionMixin};
  color: ${({ theme }) => theme.colors.textQuote()};
  margin-top: 40px;
`;

export const PriceTransparencyWarning = () => (
  <Container>
    <FormattedMarkdown id="general.priceTransparency.warning" />
  </Container>
);
